import { render, staticRenderFns } from "./LinkInputs.vue?vue&type=template&id=1153d07c"
import script from "./LinkInputs.vue?vue&type=script&lang=js"
export * from "./LinkInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports